<template>
  <div id="content">
    <div v-if="shouldShowResult">
      <div v-if="shouldShowResultAll">
        <div class="totalTitle__container">{{ $t('eventResultTotal') }}</div>
        <result-total-cell
          v-for="target in [broadcast, watch, score]"
          :key="target.name"
          :eventIconUrl="event.iconUrl"
          :showScore="event.showScore"
          :name="target.name"
          :value="target.value"
          :icon="target.imgIcon"
        ></result-total-cell>
        <div class="totalTitle__container">
          {{ $t('eventResultIndividual') }}
        </div>
      </div>
      <div v-if="isChangeResults">
        <div v-if="targetResult" class="rankView">
          <div class="rankView__header">
            {{
              $t(hasRank ? 'rankingHeaderUser' : 'scoreHeaderUser', {
                userName: targetResult.Streamer.nickname,
              })
            }}
          </div>
          <result-cell :event="event" :result="targetResult" />
        </div>
        <div v-else-if="myResult" class="rankView">
          <div class="rankView__header">
            {{
              $t(hasRank ? 'rankingHeaderUser' : 'scoreHeaderUser', {
                userName: myResult.Streamer.nickname,
              })
            }}
          </div>
          <result-cell :event="event" :result="myResult" />
        </div>

        <div class="rankView">
          <div class="rankView__header">
            {{ $t(hasRank ? 'rankingHeaderAll' : 'scoreHeaderAll') }}

            <span class="rankView__header__participantsCounterContainer">
              <span class="rankView__header__participantsCounter">
                <img class="rankView__header__participantsCounterIcon" src="/img/icon-person.svg" />
                <span class="rankView__header__participantsCounterText">{{ numOfParticipants }}</span>
              </span>
            </span>
          </div>
          <result-cell
            v-for="result in results"
            :key="result.name"
            :event="event"
            :result="result"
          />
        </div>
      </div>
    </div>
    <div v-else class="emptyState__container">
      <img class="emptyState__img" :src="asset.icon" />
      <div class="emptyState__description" v-html="this.emptyText"></div>
    </div>
  </div>
</template>

<script>
import formatter from '@/utils/Formatter'
import ResultTotalCell from './ResultTotalCell.vue'
import ResultCell from './ResultCell.vue'

export default {
  components: {
    ResultTotalCell,
    ResultCell,
  },
  name: 'Result',
  data: function () {
    return {
      asset: {
        icon: '/img/noDisplayIcon.png',
      },
      isEnableBottom: true,
      broadcast: {
        name: '',
        value: '',
        imgIcon: '/img/totalIconStream.svg',
      },
      watch: {
        name: '',
        value: '',
        imgIcon: '/img/totalIconClock.svg',
      },
      score: {
        name: '',
        value: '',
        imgIcon: '/img/totalIconScore.svg',
      },
      isChangeResults: true,
    }
  },
  props: {
    results: Array,
    event: {},
    isEntried: Boolean,
    myResult: Object,
    targetResult: Object,
    numOfParticipants: Number,
  },
  watch: {
    event: function () {
      this.isChangeResults = false
      this.createTotalView()
      this.$nextTick(() => (this.isChangeResults = true))
    },
  },
  methods: {
    handleScroll: function (event) {
      var scrolling =
        (document.documentElement.scrollTop || document.body.scrollTop) +
        document.documentElement.offsetHeight -
        document.documentElement.scrollHeight
      if (scrolling >= -70 && this.isEnableBottom) {
        this.isEnableBottom = false
        setTimeout(this.enableBottom, 500)
        this.$emit('scrolledToBottom')
      }
    },
    enableBottom() {
      this.isEnableBottom = true
    },
    getShowResultAllHourMin: function (allSec) {
      var hour = Math.floor(allSec / 3600)
      var minSec = allSec % 3600
      var min = Math.floor(minSec / 60)
      var secSec = minSec % 60
      // 31秒以上で切り上げ
      if (secSec > 30) {
        min += 1
        if (min > 59) {
          hour += 1
          min = 0
        }
      }
      min = min < 10 ? '0' + min : min
      return this.$t('eventResultBroadcastTimeFormat', { hour, min })
    },
    createTotalView() {
      // 配信
      if (this.event.showAllBroadcast == 1) {
        this.broadcast.name = this.$t('eventResultBroadcastTimeTotal')
        this.broadcast.value = this.getShowResultAllHourMin(
          this.event.broadcastTotal
        )
      } else if (this.event.showAllBroadcast == 2) {
        this.broadcast.name = this.$t('eventResultBroadcastTimeAverage')
        this.broadcast.value = this.getShowResultAllHourMin(
          this.event.broadcastAverage
        )
      } else {
        this.broadcast.name = ''
        this.broadcast.value = ''
      }
      // 視聴
      if (this.event.showAllWatch == 1) {
        this.watch.name = this.$t('eventResultViewingTimeTotal')
        this.watch.value = this.getShowResultAllHourMin(this.event.watchTotal)
      } else if (this.event.showAllWatch == 2) {
        this.watch.name = this.$t('eventResultViewingTimeAverage')
        this.watch.value = this.getShowResultAllHourMin(this.event.watchAverage)
      } else {
        this.watch.name = ''
        this.watch.value = ''
      }
      // ポイント
      if (this.event.showAllScore == 1) {
        this.score.name = this.$t('eventResultGiftPointTotal')
        this.score.value = formatter.numberWithCommas(this.event.scoreTotal)
      } else if (this.event.showAllScore == 2) {
        this.score.name = this.$t('eventResultGiftPointAverage')
        this.score.value = formatter.numberWithCommas(this.event.scoreAverage)
      } else {
        this.score.name = ''
        this.score.value = 0
      }
    },
  },
  computed: {
    emptyText() {
      if (this.event === undefined) {
        return ''
      }
      const texts = [
        this.$t('eventNotStarted'),
        this.$t('eventNoParticipant'),
        this.$t('eventAggregating'),
      ]
      return texts[this.event.status]
    },
    shouldShowResult: function () {
      if (this.event === undefined) {
        return false
      }

      if (
        this.results.length === 0 &&
        (this.event.status === 4 || this.event.status === 1 || this.event.status === 0)
      ) {
        return false
      }

      return (
        this.event.status === 0 || // 開催前
        this.event.status === 1 || // 開催中
        this.event.status === 3 || // 終了(集計完了)
        this.event.status === 4    // 終了(公開終了)
      )
    },
    shouldShowResultAll: function () {
      return (
        this.broadcast.name != '' ||
        this.watch.name != '' ||
        this.score.name != ''
      )
    },
    hasRank() {
      return this.event.eventType !== 2 // スコア達成型は順位がない
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
    this.isEnableBottom = true
    this.createTotalView()
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
    this.isEnableBottom = false
  },
}
</script>

<style scoped>
.totalTitle__container {
  height: 34px;
  max-width: 500px;
  background-color: #fafafa;
  text-align: center;
  line-height: 34px;
  font-size: 14px;
  color: #262626;
  margin: 0 auto;
}
.emptyState__container {
  text-align: center;
}
.emptyState__img {
  margin: 40px auto 10px;
  height: 96px;
  widows: 96px;
}
.emptyState__description p {
  font-size: 14px;
  padding: 0 20px;
}
.rankView {
  max-width: 500px;
  margin: 0 auto;
}
.rankView__header {
  max-width: 500px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  font-weight: bold;
  padding: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rankView__header__participantsCounter {
  font-family: "Hiragino Kaku Gothic ProN";
  vertical-align: text-top;
  margin-left: 6px;
}

.rankView__header__participantsCounterIcon {
  height: 16px;

  vertical-align: text-top;
}

.rankView__header__participantsCounterText {
  height: 16px;
  font-size: 13px;
  font-weight: normal;
  line-height: 16px;
  margin-left: 5px;
  color: #262626;

  vertical-align: text-top;
}

.rankView__header__participantsCounterContainer {
  height: 16px;
  line-height: 16px;
  vertical-align: text-top;
}

</style>
